
// src/app/config/config.tokens.ts
import { InjectionToken } from '@angular/core';
import {
    AppMeta,
    AuthConfig,
    DiagnosticsMeta,
    EnvironmentMeta,
    Features,
    GeographicalSummaryConfig,
    ProductIdentity,
    ProductUris,
    MembershipConfig,
    UserManagerConfig,
    MessageofTheDayConfig,
    EgoConfig
} from './config.model';

export const PRODUCT_IDENTITY_TOKEN = new InjectionToken<ProductIdentity>('PRODUCT_IDENTITY_TOKEN');

export const APP_META_TOKEN = new InjectionToken<AppMeta>('APP_META_TOKEN');
export const ENVIRONMENT_META_TOKEN = new InjectionToken<EnvironmentMeta>('ENVIRONMENT_META_TOKEN');
export const DIAGNOSTICS_META_TOKEN = new InjectionToken<DiagnosticsMeta>('DIAGNOSTICS_META_TOKEN');
export const DEBUG_INFO_TOKEN = new InjectionToken<boolean>('DEBUG_INFO_TOKEN');

export const MEMBERSHIP_CONFIG_TOKEN = new InjectionToken<MembershipConfig>('MEMBERSHIP_CONFIG_TOKEN');
export const AUTH_CONFIG_TOKEN = new InjectionToken<AuthConfig>('AUTH_CONFIG_TOKEN');
export const FEATURES_TOKEN = new InjectionToken<Features>('FEATURES_TOKEN');
export const PRODUCT_URIS_TOKEN = new InjectionToken<ProductUris>('PRODUCT_URIS_TOKEN');

export const USER_MANAGER_CONFIG_TOKEN = new InjectionToken<UserManagerConfig>('USER_MANAGER_CONFIG_TOKEN');
export const MESSAGE_OF_THE_DAY_CONFIG_TOKEN = new InjectionToken<MessageofTheDayConfig>('MESSAGE_OF_THE_DAY_CONFIG_TOKEN');
export const GEOGRAPHICAL_SUMMARY_CONFIG_TOKEN = new InjectionToken<GeographicalSummaryConfig>('GEOGRAPHICAL_SUMMARY_CONFIG_TOKEN');
export const EGO_TOKEN = new InjectionToken<EgoConfig>('EGO_TOKEN');
